import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* istanbul ignore file */
import { DropInPaymentsCommandNames } from '@chegg/commerce-utils';
import { useEffect, useState } from 'react';
import { setApolloState } from '../lib/ApolloSchema/apolloUtils';
import { removeMediaQuery, setupMediaQuery } from '../views/CartCheckout/helpers';
import { reactiveAltProductData } from '../lib/ApolloSchema/reactiveVars';
import { useReactiveVar } from '@apollo/client';
// Initialize Cart Checkout state (set Dropin Payments Add Item command, Apollo state, and media query functionality)
export var useCartCheckoutInitializeState = function useCartCheckoutInitializeState(_ref) {
  var apolloState = _ref.apolloState,
    itemData = _ref.itemData,
    hostAnnotations = _ref.hostAnnotations,
    reviewStepEnabled = _ref.reviewStepEnabled,
    allowPlanSelection = _ref.allowPlanSelection,
    couponCode = _ref.couponCode,
    _ref$useAutoAppliedCo = _ref.useAutoAppliedCoupons,
    useAutoAppliedCoupons = _ref$useAutoAppliedCo === void 0 ? true : _ref$useAutoAppliedCo,
    isRecurly = _ref.isRecurly;
  var _useReactiveVar = useReactiveVar(reactiveAltProductData),
    altItemData = _useReactiveVar.altItemData;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    dipCommands = _useState2[0],
    setDipCommands = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobile = _useState4[0],
    setIsMobile = _useState4[1];

  // TODO Add test for this line.  how?
  // istanbul ignore next
  var isReviewStep = (apolloState === null || apolloState === void 0 ? void 0 : apolloState.reviewData.currentStep) === 2;
  useEffect(function () {
    //TODO: refactor command interfaces in DIP to provide better experience for clients
    //On initialization set commands to add an item to cart
    var promos = couponCode && couponCode.length > 0 ? [couponCode] : undefined;
    setDipCommands(isRecurly ? [] : [{
      commandName: DropInPaymentsCommandNames.ADD_ITEM,
      data: {
        // initially add alt item in upsell flow so we can fetch discounted price
        // then, we will replace this with the primary item
        itemData: altItemData.length > 0 ? altItemData : itemData,
        hostAnnotations: hostAnnotations,
        promotions: promos,
        useAutoAppliedCoupons: useAutoAppliedCoupons
      }
    }]);
    reviewStepEnabled && setApolloState({
      reviewData: {
        currentStep: 1
      }
    });

    // Unmounting the component renders isReviewStep as true first
    // resulting it does not update the rio config if the component is unmounted
    isReviewStep = false;
    setupMediaQuery(setIsMobile, allowPlanSelection);
    return function () {
      removeMediaQuery();
      setApolloState({
        uiData: {
          errorMessage: '',
          isLoaded: false
        }
      });
    };
  }, []);
  return {
    dipCommands: dipCommands,
    setDipCommands: setDipCommands,
    isMobile: isMobile,
    setIsMobile: setIsMobile,
    isReviewStep: isReviewStep
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/hooks/useCartCheckoutInitializeState.js
// module id = 4198
// module chunks = 11